import Firebase from 'firebase'

const firebaseApp = Firebase.initializeApp({
  apiKey: "AIzaSyCCN3USnjztk1GcnrHVScsyRvedRdpI7YQ",
  authDomain: "vue-trial-1.firebaseapp.com",
  databaseURL: "https://vue-trial-1.firebaseio.com",
  projectId: "vue-trial-1",
  storageBucket: "vue-trial-1.appspot.com",
  messagingSenderId: "136352030230"
});

export const auth = firebaseApp.auth()
export const db = firebaseApp.database();



// WEBPACK FOOTER //
// ./src/components/firebase.js